import styled from 'styled-components';
import { media } from '@minerva-analytics/pantheon';
import { BLACK, WHITE, FOOTER_HEIGHT } from 'root/theme';

const FooterContainer = styled.footer`
  background: ${WHITE};
  color: ${BLACK};
  font-size: 0.825rem;
  height: 100%;
  line-height: calc(${FOOTER_HEIGHT} - 2rem);
  padding: 1rem;
  text-align: center;
  ${media.phone`
    font-size: 0.75rem;
    line-height: inherit;
  `}
`;

export {
  FooterContainer,
};
